import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Install/Projects/lk_creative/layouts/default.vue")),
  guest: defineAsyncComponent(() => import("C:/Install/Projects/lk_creative/layouts/guest.vue")),
  lk: defineAsyncComponent(() => import("C:/Install/Projects/lk_creative/layouts/lk.vue"))
}